
import { useStore } from "@/stores/order";
import { useForm } from "@inertiajs/inertia-vue3";
import dayjs from "dayjs";
import { defineComponent } from "vue";
import Modal from "../General/Modal.vue";
import Button from "../Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiClose, mdiLoading } from "@mdi/js";

export default defineComponent({
  emits: ['dismiss'],
  setup(props, context) {
    const orderStore = useStore();

    const form = useForm({
      date: dayjs().format("YYYY-MM-DD"),
      amount: orderStore.totalIncMva,
      complete: false,
    });

    const sendForm = () => {
      form.post(route("orders.invoice.pay", { order: orderStore.order_id }), {
        onSuccess: () => {
          context.emit("dismiss");
        }
      });
    }

    const setTotalAmount = () => {
      form.amount = orderStore.totalIncMva;
    }

    return {
      form,
      sendForm,
      setTotalAmount,
      loadingIcon: mdiLoading,
      closeIcon: mdiClose,
    };
  },
  components: { Modal, Button, SvgIcon }
});
